(function () {
  function init() {
    var modal = document.getElementById('vagaro-modal');
    if (!modal) return;

    function openModal(e) {
      e.preventDefault();
      modal.setAttribute('data-open', '');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function closeModal() {
      modal.removeAttribute('data-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('a[href="#book-appointment"], a[href$="#book-appointment"]');
      if (trigger) {
        openModal(e);
        return;
      }
      if (e.target.closest('[data-vagaro-close]')) {
        closeModal();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeModal();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
